// Shared helpers for the AI document wizard — ported from the R&D app's lib/i18n.js
// helper functions, adapted to operate on the catalog fetched from the backend
// (GET /api/ai-documents/templates → { categories, templates, order, creditCost }).

const EN_TO_BN = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];
export const toBanglaDigits = (s) => String(s ?? '').replace(/[0-9]/g, (d) => EN_TO_BN[d]);

const L = (lang) => (lang === 'bn' ? 'bn' : 'en');

export function getCategories(catalog, lang) {
  const k = L(lang);
  return (catalog?.categories || []).map((c) => ({ id: c.id, label: c[k] }));
}

export function getTypes(catalog, lang) {
  const k = L(lang);
  const templates = catalog?.templates || {};
  return (catalog?.order || [])
    .map((id) => {
      const tpl = templates[id];
      if (!tpl) return null;
      return { id, code: tpl.code, category: tpl.category, title: tpl[k].title, desc: tpl[k].desc || '' };
    })
    .filter(Boolean);
}

export function getSchemas(catalog, lang) {
  const k = L(lang);
  const templates = catalog?.templates || {};
  const out = {};
  for (const id of catalog?.order || []) {
    const tpl = templates[id];
    if (!tpl) continue;
    out[id] = {
      name: tpl[k].name,
      fields: (tpl.fields || []).map((f) => ({
        id: f.id,
        type: f.t || 'text',
        full: !!f.full,
        label: f[k][0],
        placeholder: f[k][1],
        suggest: f.sg ? f.sg[k] || [] : [],
      })),
    };
  }
  return out;
}

const CHIP_IDS = ['name_correction', 'general_affidavit', 'rent_agreement', 'general_application', 'lost_document'];
export function getChips(catalog, lang) {
  const k = L(lang);
  const templates = catalog?.templates || {};
  return CHIP_IDS.filter((id) => templates[id]).map((id) => ({ label: templates[id][k].title, type: id }));
}

// Live suggestions for the custom box: rank templates by keyword/title match.
export function suggestTypes(catalog, query, lang, limit = 6) {
  const k = L(lang);
  const templates = catalog?.templates || {};
  const order = catalog?.order || [];
  const q = (query || '').toLowerCase().trim();
  if (!q) return getChips(catalog, lang);
  const tokens = q.split(/\s+/).filter((t) => t.length > 1);
  if (tokens.length === 0) return getChips(catalog, lang);
  const scored = [];
  for (const id of order) {
    const tpl = templates[id];
    if (!tpl) continue;
    const hay = [tpl.en.title, tpl.en.desc, tpl.bn.title, tpl.bn.desc, ...(tpl.kw || [])].join(' ').toLowerCase();
    let score = 0;
    for (const tk of tokens) if (hay.includes(tk)) score += 1;
    if (score > 0) scored.push({ score, label: tpl[k].title, type: id });
  }
  scored.sort((a, b) => b.score - a.score);
  return scored.slice(0, limit).map(({ label, type }) => ({ label, type }));
}
